import i18next from 'i18next';

i18next.addResources('en', 'AdelphiCaskFillingById', {
  newCaskFillings: 'Add a new excel',
  caskNumber: 'Cask No',
  caskType: 'Cask Type',
  filledFor: 'Filled For',
  groos: 'Groos',
  tare: 'Tare',
  net: 'Net'
});
